module.exports = __webpack_public_path__ + "static/img/seed-text.36aef9df.png";